/**
 * @Author: Nenad Brcic
 * @Date: 16.10.16
 * @Email: neno@neno.ch
 */

import expires from 'expires';
import settings from '../config/settings';
import { getUrlParameter } from './common';

const vitraStorage = JSON.parse(window.localStorage.getItem('vitra')) || {};
let isLocalStorageSupported = false;

const testLocalStorageSupport = () => {
    var testKey = 'test', storage = window.sessionStorage;
    try {
        storage.setItem(testKey, '1');
        storage.removeItem(testKey);
        isLocalStorageSupported = true;
        return isLocalStorageSupported;
    } catch (error) {
        return isLocalStorageSupported;
    }
};
testLocalStorageSupport();

const updateVitraStorage = () => {
    if (isLocalStorageSupported) {
        window.localStorage.setItem('vitra', JSON.stringify(vitraStorage));
    }
};

const deleteExpirationTimestamp = () => {
    delete vitraStorage.timestamp;
    updateVitraStorage();
};

const removeURLParameter = (url, parameter) => {
    //prefer to use l.search if you have a location/link object
    const urlparts = url.split('?');
    if (urlparts.length>=2) {

        var prefix= encodeURIComponent(parameter)+'=';
        var pars= urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (let i= pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
};

export function expireVisit() {
    if(!!settings.expire) {
        const { param, value, after } = settings.expire;
        if(!!param && !!value &&after) {
            if(getUrlParameter(param) === value) {
                const expiresAt = expires.after(after);
                vitraStorage.visitExpiresAt = expiresAt;
                updateVitraStorage();
                const url = removeURLParameter(window.location.href, settings.expire.param);
                window.location.replace(url);
            }
        }
    }
}

export function redirectIfVisitExpired() {
    if(!!settings.expire) {
        if(!vitraStorage.visitExpiresAt || expires.expired(vitraStorage.visitExpiresAt)) {
            const redirectUrl = settings.expire.redirectUrl;
            if(!!redirectUrl) {
                deleteExpirationTimestamp();
                window.location.replace(redirectUrl);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./app/expiration.js